import { processingRessponse } from './processingRessponse'
import { getParam } from "./getParam";

export const repeatedRequest = () => {
  let url = '/ajax/state'
  const uid = getParam('uid')

  if (uid) {
    url += '?uid=' + uid
  }

  $.ajaxSetup({ cache: false })
  $.ajax({
    url: url,
    type: 'GET',
    success: function (response) {
      processingRessponse(response.data.processing, response.data)
    },
  })
}
